import React from 'react';

const TruckAnimationPanel = ({ 
  waypoints,
  isAnimating,
  animationProgress,
  onRemoveWaypoint,
  onStartAnimation,
  onStopAnimation,
  onClear
}) => {

  return (
    <div className="truck-animation-panel">
      <div className="truck-panel-header">
        <h3>🚚 Truck Route Animation</h3>
        <button className="truck-close-btn" onClick={onClear}>✕</button>
      </div>

      <div className="truck-panel-body">
        {/* Instructions */}
        <div className="truck-input-section">
          <div className="truck-instruction-box">
            <h4>📍 Click on map to add waypoints</h4>
            <ol style={{ margin: '8px 0', paddingLeft: '20px', fontSize: '13px' }}>
              <li>First click: <strong>Source</strong> 🏁</li>
              <li>Clicks 2-4: <strong>Facilities</strong> 🏢</li>
              <li>Last click: <strong>Destination</strong> 🎯</li>
            </ol>
            <div className="truck-hint">
              {waypoints.length === 0 && '👆 Click anywhere on the map to start'}
              {waypoints.length === 1 && '✅ Source added! Click 3 more times for facilities'}
              {waypoints.length > 1 && waypoints.length < 5 && `✅ ${waypoints.length} points added! Click ${5 - waypoints.length} more time(s)`}
              {waypoints.length === 5 && '🎉 All 5 points added! Ready to animate'}
              {waypoints.length > 5 && '⚠️ Maximum 5 points. Remove some to add more.'}
            </div>
          </div>
        </div>

        {/* Waypoints List */}
        {waypoints.length > 0 && (
          <div className="truck-waypoints-list">
            <h4>Route ({waypoints.length} points)</h4>
            {waypoints.map((wp, idx) => (
              <div 
                key={idx} 
                className={`truck-waypoint-item ${isAnimating && animationProgress > (idx / waypoints.length) ? 'visited' : ''}`}
              >
                <span className="truck-waypoint-icon">
                  {wp.type === 'source' ? '🏁' : wp.type === 'destination' ? '🎯' : '🏢'}
                </span>
                <div className="truck-waypoint-info">
                  <strong>{wp.name}</strong>
                  <small>{wp.lat.toFixed(6)}, {wp.lng.toFixed(6)}</small>
                </div>
                {!isAnimating && (
                  <button 
                    className="truck-remove-btn"
                    onClick={() => onRemoveWaypoint(idx)}
                  >
                    🗑️
                  </button>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Animation Controls */}
        {waypoints.length >= 2 && (
          <div className="truck-controls">
            {!isAnimating ? (
              <button onClick={onStartAnimation} className="truck-start-btn">
                ▶️ Start Animation
              </button>
            ) : (
              <button onClick={onStopAnimation} className="truck-stop-btn">
                ⏸️ Stop Animation
              </button>
            )}
            
            {isAnimating && (
              <div className="truck-progress">
                <div className="truck-progress-bar">
                  <div 
                    className="truck-progress-fill" 
                    style={{ width: `${animationProgress * 100}%` }}
                  ></div>
                </div>
                <span>{Math.round(animationProgress * 100)}% complete</span>
              </div>
            )}
          </div>
        )}

        {waypoints.length === 1 && (
          <div className="truck-hint">
            ℹ️ Add at least one more point to create a route
          </div>
        )}
      </div>
    </div>
  );
};

export default TruckAnimationPanel;

